// Utility to access $auth in both SSR and client contexts from Pinia stores

export const getAuth = () => {
  if (typeof process !== 'undefined' && process.client && typeof window !== 'undefined') {
    return window.$auth || (window.$nuxt && window.$nuxt.$auth) || null
  }

  // For SSR, we need to access it through the Nuxt context
  // This will be available if the plugin has been loaded
  if (typeof process !== 'undefined' && process.server && global.__NUXT_AUTH__) {
    return global.__NUXT_AUTH__
  }
  return null
}

export const getLog = () => {
  if (typeof process !== 'undefined' && process.client && typeof window !== 'undefined') {
    return (window.$nuxt && window.$nuxt.$log) || null
  }

  if (typeof process !== 'undefined' && process.server && global.__NUXT_LOG__) {
    return global.__NUXT_LOG__
  }
  return null
}
